import { render, staticRenderFns } from "./ParticipateEditor.vue?vue&type=template&id=6d2a9791"
import script from "./ParticipateEditor.vue?vue&type=script&lang=ts"
export * from "./ParticipateEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports